import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import { DataGrid, gridClasses } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { FORM_LIST_FOR_CLIENT_QUERY } from "../../graphQL/form_qry";
import { EDIT_TERM_MUTATION } from "../../graphQL/term_qry";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },

  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginLeft: 5,
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));

export default function TermInfoInputDialog({ closeDialog, termInfo }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState({
    termName: "",
    form: "",
    noOfSeats: "",
  });
  const [termName, setTermName] = useState(termInfo.name);
  const [noOfSeats, setNoOfSeats] = useState(termInfo.noOfSeats);
  const [clientFormList, setClientFormList] = useState([]);
  const [selectedForm, setSelectedForm] = useState(termInfo.formId.formId);
  const [alertMsg, setAlertMsg] = useState([]);
  const [updatedTermInfo, setUpdatedTermInfo] = useState(termInfo);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to 00:00:00 to compare only the date part
  const isDisabled = today > new Date(termInfo.endDate);

  let clientId = 1;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");
  const [fetchClinetFormList] = useManualQuery(FORM_LIST_FOR_CLIENT_QUERY, {
    fetchPolicy: "network-only",
  });

  const [editTerm] = useMutation(EDIT_TERM_MUTATION, {
    awaitRefetchQueries: true,
  });

  function dayFormatSlashSeparated(day) {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const formatter = new Intl.DateTimeFormat("en-US", options);
    return formatter.format(new Date(day));
  }

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog(updatedTermInfo);
  };

  useEffect(() => {
    (async () => getFormlist())();
  }, []);

  const getFormlist = async () => {
    console.log(clientId);
    const {
      loading: loadingClientForm,
      error: errorClientForm,
      data: dataClientForm,
    } = await fetchClinetFormList({
      variables: {
        clientId: parseInt(clientId),
      },
    });

    if (!loadingClientForm && dataClientForm && dataClientForm.formListForClient) {
      let formList = dataClientForm.formListForClient.map(item => ({
        ...item,
        checked: item.formId === termInfo.formId.formId ? true : false,
        disabled: item.formId === termInfo.formId.formId ? false : true,
      }));
      setClientFormList(formList);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Form Name",
      headerClassName: "super-app-theme--header",
      minWidth: 170,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "date",
      headerClassName: "super-app-theme--header",
      headerName: "Date Created",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "terms",
      headerClassName: "super-app-theme--header",
      headerName: "Used in Sprints",
      minWidth: 170,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "select",
      headerClassName: "super-app-theme--header",
      headerName: "Select",
      minWidth: 70,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return rows.row.status === "Published" ? (
          <Checkbox
            onChange={handleCheckBoxChange}
            id={rows.row.id}
            defaultChecked={rows.row.checked}
            disabled={rows.row.disabled}
          />
        ) : (
          ""
        );
      },
    },
  ];

  const rows = clientFormList
    .filter(frm => frm.approved === true)
    .map((frm, index) => ({
      index,
      id: frm.formId,
      name: frm.name,
      date: dayFormatSlashSeparated(frm.createDate),
      terms: frm.termList,
      status: "Published", // Since only approved forms are included
      checked: frm.checked,
      disabled: frm.disabled,
    }));

  const handleCheckBoxChange = e => {
    let checked = false;
    let disabled = true;
    if (e.target.checked) {
      setSelectedForm(e.target.id);
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        form: "",
      }));
    } else {
      setSelectedForm(0);
      //checked = false;
    }
    let chgClientForm = clientFormList;
    //if unchecked enable other checkboxes otherwise disabled them
    for (let i = 0; i < clientFormList.length; i++) {
      if (clientFormList[i].approved == true && e.target.id != clientFormList[i].formId) {
        if (e.target.checked == true) {
          checked = false;
          disabled = true;
        } else {
          checked = false;
          disabled = false;
        }

        chgClientForm = findAnd.changeProps(
          chgClientForm,
          { formId: clientFormList[i].formId },
          {
            disabled: disabled,
            checked: checked,
          }
        );
      }
    }

    setClientFormList(chgClientForm);
  };

  const handleTermNameChange = event => {
    if (event.target.value.trim() === "")
      setErrorMsg({ termName: "Term Name cannot be blank." });
    else setErrorMsg({ termName: "" });
    setTermName(event.target.value);
  };

  const handleNoOfSeatsChange = event => {
    if (parseInt(event.target.value) < 1) {
      setErrorMsg({ noOfSeats: "Enter an integer greater than zero." });
    } else if (event.target.value.toString().trim() === "") {
      setErrorMsg({ noOfSeats: "No of Seats cannot be blank." });
    } else {
      setErrorMsg({ noOfSeats: "" });
      setNoOfSeats(parseInt(event.target.value));
    }
  };

  const handleSave = async () => {
    if (termName.trim() === "") {
      setErrorMsg({ termName: "Term Name cannot be blank." });
    } else if (noOfSeats < 1) {
      setErrorMsg({ noOfSeats: "Enter an integer greater than zero." });
    } else if (!noOfSeats) {
      setErrorMsg({ noOfSeats: "No of Seats cannot be blank." });
    } else if (selectedForm == 0) {
      setErrorMsg({ form: "Please Select a form" });
    } else {
      let startDate = dayjs(termInfo.startDate).toISOString().slice(0, 10);
      let endDate = dayjs(termInfo.endDate).toISOString().slice(0, 10);
      const { data, error } = await editTerm({
        variables: {
          name: termName,
          formId: parseInt(selectedForm),
          startDate: startDate,
          endDate: endDate,
          urlActivated: termInfo.urlActivated,
          noOfSeats: parseInt(noOfSeats),
          termUuid: termInfo.termUuid,
        },
      });
      if (error) {
        console.log("Error", error, data);
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      } else if (data && data.editTerm) {
        console.log("Success", data.editTerm.term);
        setUpdatedTermInfo(data.editTerm.term);
        handleClose();
      }
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: "100%",
              maxWidth: "600px",
              maxHeight: "700px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 0,
          }}
        >
          <Box mt={1} ml={1}>
            Term Info
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>

        <Box pt={1} pb={1} style={{ display: "flex", justifyContent: "center" }}>
          <Typography variant="h1" style={{ fontSize: 20 }}>
            This term belongs to client: {clientName}
          </Typography>
        </Box>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              autoFocus
              required
              disabled={isDisabled}
              label="Term Name"
              margin="normal"
              name="termName"
              variant="outlined"
              id="termName"
              defaultValue={termName}
              onChange={handleTermNameChange}
            />
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.termName}
              </FormHelperText>
            )}

            <Box
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <TextField
                className={classes.textFieldStyle}
                style={{ paddingRight: 5 }}
                fullWidth
                disabled
                label="Start Date"
                margin="normal"
                name="startDate"
                variant="outlined"
                id="startDate"
                value={dayFormatSlashSeparated(termInfo.startDate)}
              />
              <TextField
                className={classes.textFieldStyle}
                fullWidth
                disabled
                label="End Date"
                margin="normal"
                name="endDate"
                variant="outlined"
                id="endDate"
                value={dayFormatSlashSeparated(termInfo.endDate)}
              />
            </Box>

            <TextField
              className={classes.textFieldStyle}
              fullWidth
              disabled
              label="No of Weeks"
              margin="normal"
              name="noOfWeeks"
              type="number"
              value={termInfo.noOfWeeks}
              variant="outlined"
              id="noOfWeeks"
            />

            <TextField
              className={classes.textFieldStyle}
              fullWidth
              autoFocus
              required
              disabled={isDisabled}
              label="No of Seats"
              margin="normal"
              name="noOfSeats"
              type="number"
              variant="outlined"
              id="noOfSeats"
              defaultValue={noOfSeats}
              onChange={handleNoOfSeatsChange}
              InputProps={{
                inputProps: { min: 1, pattern: "^[1-9][0-9]?$", max: 99 },
              }}
            />
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.noOfSeats}
              </FormHelperText>
            )}

            <TextField
              className={classes.textFieldStyle}
              fullWidth
              disabled
              label="Term Template Ref."
              margin="normal"
              name="termTmpRef"
              value={termInfo.termTemplateId}
              variant="outlined"
              id="termTmpRef"
            />

            <Typography variant="h3">
              Term Activation{" "}
              <Checkbox
                defaultChecked={termInfo.urlActivated}
                disabled
                id="Term Activation"
              />
            </Typography>
            
            <Typography variant="h3">
              Current Term{" "}
              <Checkbox
                defaultChecked={termInfo.current}
                disabled
                id="Current Term"
              />
            </Typography>

            <Box pt={1} pb={1} style={{ display: "flex", justifyContent: "center" }}>
              <Typography variant="h1" style={{ fontSize: 20 }}>
                Select a published form for this client: {clientName}
              </Typography>
            </Box>
            <DataGrid
              className={classes.dataGridStyle}
              columns={columns}
              rows={rows}
              showCellRightBorder={true}
              hideFooter={true}
              autoWidth={true}
              getRowId={row => row.id}
              getRowClassName={params => {
                if (params.row.index % 2 === 0) return "even";
                else return "odd";
              }}
              autoHeight={true}
              experimentalFeatures={{ newEditingApi: true }}
            />
            {errorMsg.form && (
              <Box pt={1}>
                <FormHelperText className={classes.errorStyle} error>
                  {errorMsg.form}
                </FormHelperText>
              </Box>
            )}
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center", marginTop: 15 }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
              disabled={isDisabled}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
